import { RootScopeEvents } from './root-scope-types';
import { EndCallReasons } from './doxy-analytics/tracks/video-session-end';
import { extensionIntegrEvents } from '../../modules/extensions-framework/angular-integration/integration-types';
const WAIT_FOR_PAUSED_TIMEOUT = 1000;
/**
 * Needed to distinct DOCTOR_LEFT from PAUSED on patient side
 * Resolve PAUSED event on Patient side when provider paused a call
 * because DOCTOR_LEFT is is triggering first in both cases:
 * - when provider closed tab;
 * - when provider paused
 *
 * So when EndCallReasons.PAUSED came after DOCTOR left
 * extensionIntegrEvents.PAUSED will be emitted
 */
export class PatientPauseResolver {
    constructor($rootScope) {
        this.$rootScope = $rootScope;
    }
    init() {
        let waitForPausedTimeout;
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, (_e, reason) => {
            if (reason === EndCallReasons.DOCTOR_LEFT) {
                waitForPausedTimeout = setTimeout(() => {
                    this.$rootScope.$emit(extensionIntegrEvents.DOCTOR_LEFT);
                }, WAIT_FOR_PAUSED_TIMEOUT);
            }
            if (reason === EndCallReasons.PAUSED) {
                clearTimeout(waitForPausedTimeout);
                this.$rootScope.$emit(extensionIntegrEvents.PAUSED);
            }
        });
    }
}
